import { io, type Socket } from "socket.io-client";

import { REALTIME_BASE_URL } from "@/config/api";
import { restoreMemberAccessToken } from "@/features/public/memberSession";

interface CommunitySocketOptions {
  requiresAuth?: boolean;
}

export async function connectCommunityRealtime(options: CommunitySocketOptions = {}): Promise<Socket | null> {
  if (!REALTIME_BASE_URL) {
    return null;
  }

  const token = options.requiresAuth ? await restoreMemberAccessToken() : null;

  if (options.requiresAuth && !token) {
    return null;
  }

  return io(REALTIME_BASE_URL, {
    transports: ["websocket", "polling"],
    withCredentials: true,
    auth: token ? { token } : undefined
  });
}
